import * as Yup from "yup";

export const cannedSchema = Yup.object().shape({
    short_code: Yup.string().required().label("Short Code"),
    response_text: Yup.string().required().label("Response Text"),
});
